import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

/**
 * Hides the /app/billing route entirely when:
 *  - the platform-wide billing flag is OFF, OR
 *  - the current tenant has been opted out (is_billable=false).
 * Platform admins see /app/tenants instead and don't need Billing.
 */
export default function BillingGate({ children }) {
  const { user } = useAuth();
  const [ready, setReady] = useState(false);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        if (user?.role === "platform_admin") {
          if (!cancelled) { setAllowed(false); setReady(true); }
          return;
        }
        const [p, b] = await Promise.all([
          api.get("/platform/settings").then((r) => r.data).catch(() => ({ billing_enabled: false })),
          api.get("/billing/status").then((r) => r.data).catch(() => null),
        ]);
        if (cancelled) return;
        const ok = !!p?.billing_enabled && b?.is_billable !== false && b?.status !== "disabled";
        setAllowed(ok);
        setReady(true);
      } catch {
        if (!cancelled) { setAllowed(false); setReady(true); }
      }
    })();
    return () => { cancelled = true; };
  }, [user]);

  if (!ready) {
    return (
      <div className="p-10 flex items-center justify-center">
        <Loader2 className="w-5 h-5 animate-spin text-primary" />
      </div>
    );
  }
  if (!allowed) return <Navigate to="/app" replace />;
  return children;
}
